module.exports = {
  ADD_CREDIT_DEBIT: 'Add new payment method',
  CREDIT_DEBIT_CARDS: 'Credit/Debit Cards',
  ADD_GOV_AGENCY: 'Add account',
  QUICK_BUY_TITLE: 'QuickBuy@SGov',
  GOV_EMAIL: 'Government agency email',
  VERIFY_EMAIL: 'Verify email',
  CANCEL: 'Cancel',
  LAUNCH_WORKPAL:
    'Launch your Workpal app to authenticate this request within 2 minutes.',
  HOW_AUTHENCTICATE: 'How to approve',
  REQUEST_CANCELLED: 'You cancelled your request',
  REQUEST_EXPIRED: 'Your request has expired, please try again',
  EMAIL_VERIFIED: 'Please authenticate the request via your Workpal app',
  INVALID_EMAIL: 'Invalid Email',
  EXPIRY_DURATION: 120000,
  API_INTERVAL: 5000,
  SELECT_AGENCY: 'Select an agency',
  PURCHASE_REASON_EMPTY: 'Share why you are buying these items.',
  QUICKBUY_MINIMUM_HOURS_ALLOWED: 24,
}
